import request from '@/utils/request'

/**
 * 获取缓存列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function listCache(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/cache.listCache',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 刷新缓存
 * @param {Object} params 缓存参数
 * @returns {Promise}
 */
export function flushCache(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/cache.flushCache',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}